export const PHONE_MASK = "+1 (000) 000-0000";
export const PHONE_MASK_PLACEHOLDER_CHAR = "X";
